// @ts-expect-error - vite-plugin-pwa virtual module
import { useRegisterSW } from 'virtual:pwa-register/react';

interface UpdatePromptProps {
    onDismiss?: () => void;
}

export function useUpdatePrompt() {
    const {
        needRefresh: [needRefresh, setNeedRefresh],
        updateServiceWorker,
    } = useRegisterSW({
        onRegistered(r: ServiceWorkerRegistration | undefined) {
            // Check for updates every 5 minutes
            if (r) {
                setInterval(
                    () => {
                        r.update();
                    },
                    5 * 60 * 1000
                );
            }
        },
        onRegisterError(_error: Error) {},
    });

    const update = async () => {
        await updateServiceWorker(true);
        setNeedRefresh(false);
    };

    const dismiss = () => {
        setNeedRefresh(false);
    };

    return { needRefresh, update, dismiss };
}

export function UpdatePrompt({ onDismiss }: UpdatePromptProps) {
    const { needRefresh, update, dismiss } = useUpdatePrompt();

    if (!needRefresh) return null;

    const handleDismiss = () => {
        dismiss();
        onDismiss?.();
    };

    return (
        <div
            style={{
                position: 'fixed',
                bottom: 20,
                left: 16,
                right: 16,
                background: 'var(--color-primary)',
                color: 'white',
                padding: 16,
                borderRadius: 12,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                gap: 12,
                boxShadow: '0 4px 20px rgba(0,0,0,0.3)',
                zIndex: 1000,
            }}
        >
            <span style={{ fontSize: 14, fontWeight: 500 }}>✨ New version available</span>
            <div style={{ display: 'flex', gap: 8 }}>
                <button
                    type="button"
                    className="btn btn-secondary mt-auto"
                    onClick={handleDismiss}
                    style={{
                        background: 'rgba(255,255,255,0.2)',
                        border: 'none',
                        color: 'white',
                        padding: '8px 12px',
                        borderRadius: 8,
                        cursor: 'pointer',
                        fontSize: 13,
                    }}
                >
                    Later
                </button>
                <button
                    type="button"
                    onClick={update}
                    style={{
                        background: 'white',
                        border: 'none',
                        color: 'var(--color-primary)',
                        padding: '8px 16px',
                        borderRadius: 8,
                        cursor: 'pointer',
                        fontWeight: 600,
                        fontSize: 13,
                    }}
                >
                    Update
                </button>
            </div>
        </div>
    );
}
